/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_BAN_ACCOUNTS_ITEM = {
  id: 'banks_accounts_admin',
  screenId: 'fin-ban-accounts',
  label: 'Cuentas bancarias',
  description: 'Cuentas corrientes o cajas de ahorro vinculadas a un banco.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás cada cuenta bancaria real de la empresa (cuenta corriente en pesos, caja de ahorro en dólares, etc.) y la vinculás al banco correspondiente. Esas cuentas son las que después usás en Movimientos, Conciliación y Préstamos.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'El banco debe existir previamente en el menú «Bancos».',
          'La lista muestra las cuentas a las que tenés acceso. Quien crea una cuenta queda autorizado automáticamente a usarla.',
        ],
      },
      {
        title: 'Paso 1 — Ver cuentas',
        bullets: [
          'Columnas: Cuenta (descripción), Banco, Moneda y Nº cuenta.',
          'Tocá una fila para ver el detalle completo.',
          'No hay edición desde esta pantalla: solo consulta y alta.',
        ],
      },
      {
        title: 'Paso 2 — Nueva cuenta',
        intro: 'El botón + abre «Nueva cuenta bancaria». Campos:',
        fields: [
          {
            label: 'Banco',
            description: 'Entidad bancaria ya cargada. Si no hay bancos, creá uno antes en «Bancos».',
          },
          {
            label: 'Descripción de la cuenta',
            description: 'Nombre interno obligatorio (por ejemplo «Galicia CC pesos»). No puede repetirse otra con el mismo nombre.',
          },
          {
            label: 'Número de cuenta',
            description: 'CBU, alias o número identificatorio. Opcional pero recomendable para reconocer la cuenta.',
          },
          {
            label: 'Moneda',
            description: 'Moneda en la que opera la cuenta (pesos, dólares, etc.). Obligatoria.',
          },
        ],
        paragraphs: [
          'Tocá «Crear cuenta» para guardar. La cuenta queda disponible en movimientos y conciliación según tus permisos.',
        ],
      },
      {
        title: 'Detalle de una cuenta',
        bullets: [
          'Descripción, banco, moneda y número de cuenta.',
          'Datos de auditoría (quién la creó y cuándo) si están disponibles.',
        ],
      },
    ],
  },
}
